"use client";

import { useRouter } from "next/navigation";
import {
  ProfileMagicProgressCard,
  ProfileMagicProgressCardSkeleton,
} from "@/app/components/profile-magic/ProfileMagicProgressCard";
import { useProfileMagicWorkspace } from "@/hooks/useProfileMagicWorkspace";

type Props = {
  workspaceId: string;
  compact?: boolean;
};

export function ProfileMagicServiceBanner({ workspaceId, compact }: Props) {
  const router = useRouter();
  const pm = useProfileMagicWorkspace(workspaceId);
  const continueHref = `/profile-magic?workspaceId=${encodeURIComponent(workspaceId)}`;

  if (compact) {
    return (
      <ProfileMagicProgressCard
        readiness={
          pm.readiness ?? {
            percent: 0,
            earned: 0,
            total: 100,
            milestones: [],
          }
        }
        compact
        onContinue={() => router.push(continueHref)}
      />
    );
  }

  if (pm.loading) {
    return <ProfileMagicProgressCardSkeleton />;
  }

  if (!pm.readiness || pm.readiness.percent >= 100) {
    return null;
  }

  return (
    <ProfileMagicProgressCard
      readiness={pm.readiness}
      onContinue={() => router.push(continueHref)}
    />
  );
}
